module.exports = __webpack_public_path__ + "static/media/statistics-menu.5b8a803f.svg";